import { FC, useState, useEffect, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useMethods } from '@lhb/hook';
// isArray, isNotEmpty,
// import { getDynamicDetail } from '@/common/api/expandStore/chancepoint';
import { getModelClusterDetail, getModelClusterOverView, getPDFExportStatus, getSiteModelList, /* getModelClusterSituation */ } from '@/common/api/networkplan';
import { TaskStatus } from './ts-config';
import { gatherClientStatus } from './components/GatherClientDrawer/ts-config';
import { isArray } from '@lhb/func';
import { useUnactivate } from 'react-activation';
// import cs from 'classnames';
import styles from './index.module.less';
import V2Container from '@/common/components/Data/V2Container';
import V2Drawer from '@/common/components/Feedback/V2Drawer';
import Top from './components/Top';
import Main from './components/Main';
import SkeletonMapDetail from '../../Skeleton/SkeletonMapDetail';
// import InitEvent from '@/views/iterate/pages/siteselectionmapb/components/InitEvent';
import { gatherClientList } from '@/common/api/sitemapgather';
import { newPointStatusEnum } from '@/views/iterate/pages/siteselectionmapb/ts-config';
import { getSelectionMapButton } from '@/common/api/siteselectionmap';
import { SemirModelCode } from '@/views/youth/pages/map/ts-config';
import { usePageTitle } from '@/common/hook/usePageTitle';

/**
 * 选址地图详情抽屉
 * @Description 旧版第三代选址地图
 */
const AreaDetailDrawer: FC<{
  drawerData: any;
  /** 是否显示商圈的收藏按钮 */
  showCollect?: boolean;
  /** 是否显示任务发起按钮 */
  showTaskCreate?: boolean;
  /** 是否显示任务历史按钮 */
  showTaskHistory?: boolean;
  /** 是否显示集客点录入按钮 */
  showGatherCreate?: boolean;
  setDrawerData: any;
  onLabelChanged?: any;
  labelOptionsChanged?: any;
  /** 是否可以查看机会点详情；默认可以，从机会点页跳转过来时不允许 */
  viewChanceDetail?: boolean;
  pointDrawerData?: any;
  setPointDrawerData?: any;
  modelId?: number; // 部分场景时用传入的模型id
  detailLevel?: number; // 商圈详情层级：相似商圈卡片打开二层详情时传 1，用于禁止再打开下一层
}> = ({
  drawerData,
  showCollect = true, // 是否显示商圈的收藏按钮
  showTaskCreate = true, // 是否显示任务发起按钮
  showTaskHistory = true, // 是否显示任务历史按钮
  showGatherCreate = true, // 是否显示集客点录入按钮
  setDrawerData,
  onLabelChanged,
  labelOptionsChanged,
  viewChanceDetail = true, // 是否可以查看机会点详情；默认可以，从机会点页跳转过来时不允许
  pointDrawerData,
  setPointDrawerData, // 点位抽屉开关
  modelId, // 模型id
  detailLevel, // 商圈详情层级
}) => {
  // const tenantCheckData = useSelector((state: any) => state.common.tenantCheck);
  let modelConfigId = useSelector((state: any) => state.iterate.modelConfigId); // 存放选址地图页面的当前模型
  if (modelId) {
    modelConfigId = modelId;
  }
  // 最终生效的模型配置id：getDetail 通过 getSiteModelList 兜底后回写，确保透传到 Main/FirstScreenRight 一定是有效值
  const [activeModelConfigId, setActiveModelConfigId] = useState<number>(modelConfigId);
  // 商圈详情层级：相似商圈卡片打开二层详情时传 1，用于禁止再打开下一层
  const activeDetailLevel = detailLevel ?? drawerData?.detailLevel ?? 0;
  const [configSwitch, setConfigSwitch] = useState<any>({
    isLoading: true
  });// 后台配置的开关
  const intervalForPdfRef: any = useRef();
  const openTimeRef: any = useRef<any>(0);
  const [detail, setDetail] = useState<any>({}); // 详情信息
  const [overViewData, setOverViewData] = useState<any>(); // 概览卡片
  const [loading, setLoading] = useState<boolean>(true); // 加载中
  const [pdfDataStatus, setPdfDataStatus] = useState<any>(); // 商圈报告
  const [historyVisible, setHistoryVisible] = useState<boolean>(false); // 任务历史弹框
  const [showCreateDrawer, setShowCreateDrawer] = useState<boolean>(false); // 创建拓店任务是否可见
  const [gatherClientPoint, setGatherClientPoint] = useState<any>({
    permissionConfig: {
      isPermission: false,
      text: ''
    }, // 是否有权限
    disabled: false, // 是否禁用
    legendList: [], // 图例数据-包含审批中+审批通过的
  });// 集客点按钮展示权限与状态
  const [gatherList, setGatherList] = useState<any[]>([]);// 集客点列表
  const [editModalData, setEditModalData] = useState<any>({ // 开店区域编辑弹窗
    open: false,
    data: null,
  });
  const [isSemirModel, setIsSemirModel] = useState<boolean>(false); // 是否是森马模型
  const { name: menuName } = usePageTitle();

  useEffect(() => {
    const { open, id } = drawerData;
    if (open && id) {
      methods.eventTracking();
      methods.getDetail();
      methods.getPDFStatus();
    }
    // 关闭弹窗时，将详情数据重置
    if (!open) {
      methods.eventTracking(false);
      intervalForPdfRef.current && clearInterval(intervalForPdfRef.current);
      intervalForPdfRef.current = null;
      setDetail({});
      setEditModalData({
        open: false,
        data: null,
      });
    }
  }, [drawerData]);

  // 是否是森马租户
  // const isSemir = useMemo(() => {
  //   const { isSenma } = tenantCheckData || {};
  //   return !!isSenma;
  // }, [tenantCheckData]);


  // 是否是商场类型
  const isMallType = useMemo(() => {
    const { resourceMallFlag } = detail || {};
    return !!resourceMallFlag;
  }, [detail]);
  // 选址地图页被缓存,离开当前页面时，关闭抽屉
  useUnactivate(() => {
    methods.onCloseDrawer();
  });

  const createTaskPermission = useMemo(() => {
    if (!showTaskCreate) return null;
    // 新增数据详情-审核中不显示
    if (detail?.reviewStatus === newPointStatusEnum.IN_REVIEW) return null;
    return detail?.permissions?.find((item) => item.event === 'expandShopDirect:create');
  }, [detail?.permissions]);

  const disabledCreateTask = useMemo(() => [TaskStatus.PROCESSING, TaskStatus.DESIGNATE].includes(detail?.taskStatus), [detail?.taskStatus]);

  const historyTaskPermission = useMemo(() => {
    if (!showTaskHistory) return null;
    // 新增数据详情-审核中不显示
    if (detail?.reviewStatus === newPointStatusEnum.IN_REVIEW) return null;
    const { permissions } = detail || {};
    return permissions?.find((item) => item.event === 'expandShopDirect:history');
  }, [detail]);

  // methods
  const methods = useMethods({
    getDetail: async () => { // 获取商圈详情
      setLoading(true);
      const { id } = drawerData;
      let targetModelConfigId = modelConfigId;
      if (targetModelConfigId <= 0) {
        const data = await getSiteModelList();
        targetModelConfigId = isArray(data) ? data[0]?.id : 0;
      }
      // 兜底后回写，确保透传到 Main/FirstScreenRight 的模型配置id有效（避免为 -1 导致相似商圈等模块无法请求）
      if (targetModelConfigId !== activeModelConfigId) {
        setActiveModelConfigId(targetModelConfigId);
      }

      // let targetModelConfigId: number = 0;
      // if (!modelConfigIdRef.current) {
      //   const data: any = await getSiteModelList();
      //   targetModelConfigId = isArray(data) ? data[0]?.id : 0;
      //   if (targetModelConfigId) {
      //     setModelConfigId(targetModelConfigId);
      //     modelConfigIdRef.current = targetModelConfigId;
      //   }
      // }
      Promise.all([
        getModelClusterDetail({ id, modelConfigId: targetModelConfigId }),
        // getModelClusterPopulation({ id }),
        getModelClusterOverView({ id, modelConfigId: targetModelConfigId }),
      // getModelClusterSituation({ id }), //0229版本后端将数据放在 getModelClusterDetail返回
      ])
        .then(([detailRes, overview]) => {
          const { tenantRemark } = detailRes || {};
          setEditModalData((state) => ({ ...state, data: tenantRemark }));
          setDetail(detailRes);
          const { modelConfigCode } = overview || {};
          setIsSemirModel(modelConfigCode === SemirModelCode);

          // setAgeDetail(ageDetailRes);
          setOverViewData(overview);
          // 新增数据详情-审核中不显示
          if (showGatherCreate && detailRes?.reviewStatus !== newPointStatusEnum.IN_REVIEW) {
            // 集客点按钮展示权限
            setGatherClientPoint((state) => {
              const item = detailRes?.permissions?.find((item) => item.event === 'cluster:planSpotCreate');
              return {
                ...state,
                permissionConfig: {
                  isPermission: !!item,
                  text: item?.name
                }
              };
            });
          }
        })
        .catch((error) => {
          console.error('Error fetching details:', error);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    getPDFStatus: async () => { // 获取PDF导出状态
      const data = await getPDFExportStatus({
        id: drawerData.id,
        menuName,
        type: 1, // 1:商圈 2:机会点
      });
      // exportStatus: 1:未导出 2: 导出完成 3: 导出中
      const { exportStatus } = data;
      setPdfDataStatus(data);
      // 当前是导出中而且还未创建定时器轮训
      if (exportStatus === 3 && !intervalForPdfRef.current) {
        intervalForPdfRef.current = setInterval(() => {
          methods.getPDFStatus();
        }, 5000);
      } else if (exportStatus === 2) { // 导出完成后，清空定时器
        intervalForPdfRef.current && clearInterval(intervalForPdfRef.current);
        intervalForPdfRef.current = null;
      }
    },
    eventTracking: (isOpen = true) => { // 埋点
      if (isOpen) {
        openTimeRef.current = new Date().getTime();
        return;
      }
      // 关闭的时候上报总时长
      const curTimestamp = new Date().getTime();
      const timeLag = curTimestamp - openTimeRef.current; // 停留时长
      if (openTimeRef.current && curTimestamp && timeLag > 0) {
        window.LHBbigdata.send({
          event_id: 'dcf71805-ed9e-a3e9-1c09-85daf0d49e02', // 事件id
          msg: {
            viewTimestamp: timeLag
          }
        });
        openTimeRef.current = 0;
      }
    },
    onLabelChanged() {
      onLabelChanged && onLabelChanged(); // 外部刷新回调
    },
    onCloseDrawer() {
      setDrawerData({
        open: false,
        id: '',
        rankVal: null
      });
    },
    getGatherClientList() {
      gatherClientList({
        modelClusterId: detail.id,
        // 审核中、审核通过
        spotStatusList: [2, 3]
      }).then((val) => {
        setGatherList(val);
        // 是否存在审核中的，存在则禁用
        const isExistApproval = val?.some(item => item.status === gatherClientStatus.APPROVAL) ||
        val?.length === 3 && val?.every(item => item.status === gatherClientStatus.PASS);
        // 集客点图例数据（审批中+审批通过）
        const legendList = val?.filter(item => item.status === gatherClientStatus.PASS || item.status === gatherClientStatus.APPROVAL);
        setGatherClientPoint((state) => ({
          ...state,
          disabled: isExistApproval, // 是否禁用
          legendList: legendList, // 是否展示图例
        }));
      });
    }
  });

  // 获取后台相关配置
  const handleGetSelectionMapButton = async() => {
    const data = await getSelectionMapButton({ modelConfigId: activeModelConfigId });
    setConfigSwitch({
      ...data,
      isLoading: false
    });
  };

  useEffect(() => {
    activeModelConfigId !== -1 &&
    drawerData?.open &&
    handleGetSelectionMapButton();
  }, [drawerData?.open, activeModelConfigId]);

  useEffect(() => {
    if (detail.id && gatherClientPoint.permissionConfig.isPermission) {
      methods.getGatherClientList();
    }
  }, [detail, gatherClientPoint.permissionConfig.isPermission]);

  return (
    <V2Drawer
      bodyStyle={{
        padding: 0,
      }}
      open={drawerData.open}
      destroyOnClose
      onClose={methods.onCloseDrawer}
      contentWrapperStyle={{
        width: '90%',
        minWidth: '921px', // 1024*0.9
        maxWidth: 'auto',
      }}
      className={styles.areaDetailDrawer}
    >
      {loading
        ? <SkeletonMapDetail/>
        : <V2Container
          // 容器上下padding 0， 所以减去就是0
          style={{ height: '100vh' }}
          extraContent={{
            top: <Top
              id={drawerData.id}
              detail={detail}
              // 新增数据详情-审核中不显示
              showCollect={showCollect && detail?.reviewStatus !== newPointStatusEnum.IN_REVIEW}
              rank={drawerData.rankVal}
              pdfDataStatus={pdfDataStatus}
              onLabelChanged={methods.onLabelChanged}
              labelOptionsChanged={labelOptionsChanged}
              getPDFStatus={methods.getPDFStatus}
              onRefreshGather={methods.getGatherClientList}
              createTaskPermission={createTaskPermission}
              disabledCreateTask={disabledCreateTask}
              historyTaskPermission={historyTaskPermission}
              setHistoryVisible={setHistoryVisible}
              setShowCreateDrawer={setShowCreateDrawer}
              overViewData={overViewData}
              gatherClientPoint={gatherClientPoint}
              getDetail={methods.getDetail}
              editModalData={editModalData}
              setEditModalData={setEditModalData}
              isSemirModel={isSemirModel}
            />,
          }}
        >
          <Main
            viewChanceDetail={viewChanceDetail}
            drawerData={drawerData}
            detail={detail}
            overViewData={overViewData}
            historyVisible={historyVisible}
            isMallType={isMallType}
            modelConfigId={activeModelConfigId}
            setHistoryVisible={setHistoryVisible}
            showCreateDrawer={showCreateDrawer}
            setShowCreateDrawer={setShowCreateDrawer}
            getDetail={methods.getDetail}
            pointDrawerData={pointDrawerData}
            setPointDrawerData={setPointDrawerData}
            configSwitch={configSwitch}
            setGatherClientPoint={setGatherClientPoint}
            gatherList={gatherList}
            gatherClientLegendList={gatherClientPoint?.legendList}
            editModalData={editModalData}
            isSemirModel={isSemirModel}
            detailLevel={activeDetailLevel}
          />
        </V2Container>
      }
    </V2Drawer>
  );
};

export default AreaDetailDrawer;

